<template>
    <b-card class="mb-0 mt-1" no-body>
        <b-alert
            variant="light"
            show
            dismissible
            fade
        >
            <div class="alert-body" style="" v-html="$t('Component(ReceivedRequestViewRequest):information-description')" />
        </b-alert>
        <div class="pt-1" v-if="showSourceLine">
            <u>
                {{ $t('Component(ReceivedRequestViewRequest):information-source', {customer: customer}) }}
            </u>
        </div>
    </b-card>
</template>

<script>
import { BCard, BAlert } from 'bootstrap-vue'
export default {
    components: {BCard, BAlert},
    props: {
        request: {
            required: true
        },
        showSourceLine: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        customer() {
            if (this.request && this.request.customer) {
                return this.request.customer.title;
            }
            return '';
        }
    }
}
</script>

<style scoped>

</style>
